import { IPursuit, IPartialPursuit } from 'types'

export const SET_PURSUIT = 'pursuitsPageComponent.setPursuit'
export const SET_PURSUITS = 'pursuitsPageComponent.setPursuits'
export const SET_EDIT = 'pursuitsPageComponent.setEdit'
export const DELETE_PURSUIT = 'pursuitsPageComponent.deletePursuit'

export function setPursuit(payload: IPartialPursuit) {
  return {
    type: SET_PURSUIT,
    payload
  } as const
}

export function setPursuits(payload: IPursuit[]) {
  return {
    type: SET_PURSUITS,
    payload
  } as const
}

export function setEdit(payload: { [key: number]: boolean }) {
  return {
    type: SET_EDIT,
    payload
  } as const
}

export function deletePursuit(payload: number) {
  return {
    type: DELETE_PURSUIT,
    payload
  } as const
}

export type PursuitsPageAction = ReturnType<
  typeof setPursuit | typeof setPursuits | typeof setEdit | typeof deletePursuit
>
